export class TransactionReviewError extends Error {
    constructor(transactionReviewUrl) {
        super('transaction review error');
        this.name = 'TransactionReviewError';
        this.transactionReviewUrl = transactionReviewUrl;
    }
}
export class TransactionReviewDenied extends Error {
    constructor() {
        super('transaction review has been denied by the user');
        this.name = 'TransactionReviewDenied';
    }
}
export class TransactionReviewTimeout extends TransactionReviewError {
    constructor(transactionReviewUrl, pendingTransactionId) {
        super('transaction review has timed out');
        this.name = 'TransactionReviewTimeout';
        this.transactionReviewUrl = transactionReviewUrl;
        this.pendingTransactionId = pendingTransactionId;
    }
}
